import React from 'react';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';

import Card from '@components/Card';
import FaqContent from '@src/assets/faq.md';

export default function UserProfile() {
  const markdownContent = <ReactMarkdown>{FaqContent}</ReactMarkdown>;

  return (
    <>
      <Helmet>
        <title>FAQ &middot; Enigma Screen UI FAQ</title>
      </Helmet>
      <style>{`
          h1,
          h2,
          h3 {
            letter-spacing: -0.01em;
            line-height: 1.2;
            font-weight: 600;
            margin-bottom: 0;
          }

          ol {
            list-style: disc;
          }

          ul {
            list-style: circle;
          }

          li {
            margin: 5px 0px 15px 40px;
          }

          .header {
            font-size: 72px;
            padding-bottom: 20px;
          }

          .page-title {
            font-size: 2.5rem;
            font-weight: 700;
            margin-top: 0;
            margin-bottom: 0.75em;
          }

          h1 {
            font-size: 1.875rem;
            margin-top: 50px;
            margin-bottom: 20px;
          }

          h2 {
            font-size: 1.5rem;
            margin-top: 1.5rem;
          }

          h3 {
            font-size: 1.25rem;
            margin-top: 1.25rem;
          }

          .source {
            border: 1px solid #ddd;
            border-radius: 3px;
            padding: 1.5em;
            word-break: break-all;
          }

          .callout {
            border-radius: 3px;
            padding: 1rem;
          }

          figure {
            margin: 1.25em 0;
            page-break-inside: avoid;
          }

          figcaption {
            opacity: 0.5;
            font-size: 85%;
            margin-top: 0.5em;
          }

          mark {
            background-color: transparent;
          }

          .indented {
            padding-left: 1.5em;
          }

          hr {
            background: transparent;
            display: block;
            width: 100%;
            height: 1px;
            visibility: visible;
            border: none;
            border-bottom: 1px solid rgba(55, 53, 47, 0.09);
          }

          img {
            max-width: 100%;
          }
          p {
            padding: 5px 0px;
          }

          p em {
            font-style: italic;
          }
        `}</style>
      <Card shadow>{markdownContent}</Card>
    </>
  );
}
